import type { WidgetPreset } from "../types";
import { VotePreview } from "./VoteFace";
import { VoteWidget } from "./VoteWidget";

export const VOTE: WidgetPreset = {
  id: "vote",
  label: "Vote",
  meaning: "Thumbs up or down on an idea",
  defaultWidth: 208,
  defaultHeight: 224,
  component: VoteWidget,
  resizable: { minWidth: 104, minHeight: 112 },
  preview: VotePreview,
  initialData: {},
};
